import { setPlay } from "redux/game/game.actions";
import { AppThunkDispatch } from "redux/configuration/configuration.types";

export const handleCTAClick = (
  dispatch: AppThunkDispatch,
  entityId: string | undefined,
  requestId: string
) => {
  if (!entityId) {
    return Promise.resolve();
  }
  return dispatch(setPlay(entityId, requestId));
};
